module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.c35a5d83.ttf";